import {
  Dropdown,
  Field,
  FieldProps,
  FluentProvider,
  Listbox, makeStyles,
  Option,
  OptionOnSelectData,
  PartialTheme,
  SelectionEvents,
  Slot,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";
import { JSX, useEffect, useState } from "react";
import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";

interface DropdownFieldProps {
  rcName?: string;
  theme?: string;
  name?: string;
  rcRole?: string[];
  requireRoles?: string[];
  selectedOptions?: string[];
  defaultSelectedOptions?: string[];
  multiselect?: boolean;
  disabled?: boolean;
  options?: IOption[];
  listbox?: Slot<typeof Listbox>;
  onSelectOption?: (event: SelectionEvents, data: OptionOnSelectData) => void;
  placeholder?: string;
}

export interface IOption {
  value: string;
  text: string;
  icon?: JSX.Element;
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    fontWeight: 600
  },
});

const DropdownField = (props: DropdownFieldProps & FieldProps) => {
  const styles = useStyles();
  const [options, setOptions] = useState<IOption[]>([]);
  const [mapOptions, setMapOptions] = useState<Record<string, IOption>>({});
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );

  useEffect(() => {
    setOptions([...(props.options || [])])
    const mapTemp: Record<string, any> = {};
    props.options?.forEach(item => {
      mapTemp[item.value] = item;
    })
    setMapOptions(mapTemp)
  }, [props.options])

  const onOptionSelect = (event: SelectionEvents, data: OptionOnSelectData) => {
    if (props.onSelectOption) {
      props.onSelectOption(event, data);
    }
  };
  return (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandStroke: "rgb(70, 101, 136)",
              colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
            }
      }
    >
      <Field
        label={props.label}
        validationMessage={props.validationMessage}
        validationMessageIcon={props.validationMessageIcon}
        validationState={props.validationState}
        required={props.required}
        className={styles.root}
      >
        <Dropdown
          selectedOptions={props.selectedOptions}
          defaultSelectedOptions={props.defaultSelectedOptions}
          onOptionSelect={onOptionSelect}
          multiselect={props.multiselect}
          disabled={props.disabled || !isCanBeVisible}
          listbox={props.listbox}
          placeholder={props.placeholder}
          button={props.selectedOptions?.length ? props.selectedOptions.map(item => mapOptions[item]?.text).join(", ") : undefined}
        >
          {(options || []).map((item, index) => (
            <Option key={`${props.rcName}-${index}`} value={item.value}>
              {item.text}
            </Option>
          ))}
        </Dropdown>
      </Field>
    </FluentProvider>
  );
};

export default DropdownField;
